import React from "react";
import {
  FormControlLabel,
  Switch,
  FormHelperText,
  FormControl,
} from "@mui/material";
import { useField } from "formik";

/**
 * Formik-connected Switch component
 * @param {string} name - The field name in Formik state
 * @param {string} label - The label displayed next to the switch
 */
const FormSwitchField = ({ name, label, ...props }) => {
  // We use type: 'checkbox' for useField to handle boolean values correctly
  const [field, meta, helpers] = useField({ name, type: "checkbox" });
  const errorText = meta.touched && meta.error ? meta.error : "";

  return (
    <FormControl
      error={!!errorText}
      component="fieldset"
      variant="standard"
      margin="dense"
    >
      <FormControlLabel
        control={
          <Switch
            {...field}
            {...props}
            // Ensure checked is always a boolean
            checked={!!field.value}
            // Formik's default handlechange works, but explicit setValue is safer for switches
            onChange={(e) => helpers.setValue(e.target.checked)}
            color="secondary"
          />
        }
        label={label}
        // Styling the label to match your FormTextField's font weight or style if needed
        sx={{
          "& .MuiFormControlLabel-label": {
            fontSize: "0.9rem",
            userSelect: "none",
          },
        }}
      />
      {!!errorText && (
        <FormHelperText sx={{ mt: 0 }}>{errorText}</FormHelperText>
      )}
    </FormControl>
  );
};

export default FormSwitchField;
